enum InvoiceSendTypeToNumber {
    POST = 1,
    EMAIL = 2,
}

export { InvoiceSendTypeToNumber };
